import { getMedPayPolicyLimitsLabel, getMedPayPolicyStatusLabel, getMedPayPolicyStatusLabelMP } from "../../../lib/labels"
import CheckboxCell from "../../common/interactive/CheckboxCell"

export default function MedpayPart({dataItem, classes}) {
    return <>
        {dataItem && (dataItem.has_mp || dataItem.has_pip) && <>
            <h4 className={classes.flex_betwen}>Medpay/PIP 
                <div className={classes.status}>
                    {dataItem.has_mp ? <CheckboxCell label={'MP'} checked={dataItem.has_mp} isDisabled={true} direction={'reverse'} setStyle={'box_small'}/> : ''}
                    {dataItem.has_pip ? <CheckboxCell label={'PIP'} checked={dataItem.has_pip} isDisabled={true} direction={'reverse'} setStyle={'box_small'}/> : ''}
                </div>
            </h4>
            <div className={classes.background_container}>
                <div className={classes.row}>Carrier: {dataItem.insurance_carrier?.name}</div>
                {dataItem.claim_number && <div className={classes.row}>Claim #: {dataItem.claim_number}</div>}
                
                {dataItem.has_pip ? <>
                    <hr />
                    <div className={classes.row}>
                        <div className={`${classes.flex_container_align_center} ${classes.flex_wrap} ${classes.gap_5}`}>
                            PIP: 
                            {dataItem.pip_policy_limit && <> <b>{getMedPayPolicyLimitsLabel(dataItem.pip_policy_limit)}</b> / </>}
                            {dataItem.pip_status && <><b>{getMedPayPolicyStatusLabel(dataItem.pip_status)}</b> / </>}
                            {dataItem.pip_exausted ? <CheckboxCell label={'Exhausted'} checked={true} isDisabled={true} direction={'reverse'} setStyle={'box_small'} trueFlagDanger={true}/> : ''}
                        </div>
                    </div>
                </> : ''}

                {dataItem.has_mp ? <>
                    <hr />
                    <div className={classes.row}>
                        <div className={`${classes.flex_container_align_center} ${classes.flex_wrap} ${classes.gap_5}`}>
                            MP: 
                            {dataItem.mp_policy_limit && <> <b>{getMedPayPolicyLimitsLabel(dataItem.mp_policy_limit)}</b> / </>}
                            {dataItem.mp_status && <><b>{getMedPayPolicyStatusLabelMP(dataItem.mp_status)}</b> / </>}
                            {dataItem.mp_exausted ? <CheckboxCell label={'Exhausted'} checked={true} isDisabled={true} direction={'reverse'} setStyle={'box_small'} trueFlagDanger={true}/> : ''}
                        </div>
                    </div>
                </> : ''}

                {dataItem.vehicle_model && <div className={classes.row}>
                    Vehicle:: <b>{dataItem.vehicle_model} {dataItem.vehicle_year}</b>
                    
                    {dataItem.vehicle_damage && <>, damage: <b>{dataItem.vehicle_damage}</b></>}
                </div>} 

                {dataItem.mp_attorney_received_medpay ? <>
                    <hr />
                    <div className={classes.row}>
                        <CheckboxCell label={'Commercial'} checked={true} isDisabled={true} direction={'reverse'} setStyle={'box_small'}/>
                    </div>
                </> : ''}

                {dataItem.mp_verified ? <>
                    <hr />
                    <div>Verified by <b>{dataItem.mp_verified_by}</b> at <b>{dataItem.mp_verified_date}</b></div>
                </> : ''}     
            </div>
        </>}
    </>
}